import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {Steps, Button, Row, Col, Modal, Icon, Form, Typography, Input} from 'antd';
import { Link } from "react-router-dom";
import registro from '../../img/1registro.png';
import docs from '../../img/2cargadoc.png';
import platica from '../../img/3platica.png';
import finaliza from '../../img/4finaliza.png';
import conDocs from '../../img/2condocs.png';
import conPlatica from '../../img/3conplatica.png';
import finalizado from '../../img/4finalizado.png';
import * as etiquetas from '../../ApplicationResources';
import {cargarAspirante} from '../../utils/funciones';
import HeaderModule from './Elements/HeaderModule';
import TextArea from '../interfaz/TextArea'
import ExitoDeclinacion from '../aspirante/ExitoDeclinacion';
import axios from 'axios';
import { implantarAspirante } from '../../redux/user/user-actions';
import claveContacto from '../../img/modal_contacto.png';
import errorImgModal from '../../img/error_icon.svg';

const { Step } = Steps;
const { Text } = Typography;
let msjError = "";
class GuiaEstatus extends Component { 

    constructor(props) {    
        super(props);  
        
        this.state = { 
            permiteModificar: true,
            permiteDescargar: true,
            nuevo: true,
            modalAbrir: false,
            modalAbrirDeclinacion: false,
            caracteresRetantesMotivo: 250,
            permiteDeclinar: true,
            modalContactoVisible: false,
            modalContactoInfo : [],
            msjError: "",
            abrirModalError: false,
            deshabilitarDeclinacion: false
        }; 
        this.form = this.props.form;
    }
    
    componentWillMount() {
      const datosAspirante = this.props.datosAspirante || {};
      if(datosAspirante.estatusRegistro === 0){
        this.setState({nuevo: false})   //Desaparece Modificar y Descarga en un registro nuevo
      }

      if(datosAspirante.estatusRegistro === 0  ||                                      //Si es un registro nuevo
        (datosAspirante.estatusRegistro === 1 && datosAspirante.bAcudirJDE === 1) ||   //Si es aspirante compulsado
        (datosAspirante.estatusRegistro === 2 && datosAspirante.bObservacion === 0) || //Si es aspirante validado
        (datosAspirante.compulsaPositiva === 'S') ||
         datosAspirante.estatusRegistro === 3 || datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5) { //Si es aspirante finalizado o declinado
            this.setState({permiteModificar: false})     //Deshabilita el boton para que no pueda acceder el usuario
      }

      var esClaveElectorFuar = etiquetas.REGEX_FORMATO_SOLO_DIGITOS.test(datosAspirante.claveElectorFuar);
      if(datosAspirante.estatusRegistro === 1 && esClaveElectorFuar === true) { //Si es un registro SIAP, no hay compulsa
        this.setState({permiteDescargar: false})    //Deshabilita el boton para que no pueda acceder el usuario
      }

      if(datosAspirante.estatusRegistro === 4 || datosAspirante.estatusRegistro === 5 ||
         (datosAspirante.estatusRegistro === 3 && !(datosAspirante.bAcudirJDE === 1 || datosAspirante.bObservacion === 1))  ){
        this.setState({permiteDeclinar:false});
      }
    }

    modificar = () =>{
      const datosAspirante = this.props.datosAspirante || {};
      if(datosAspirante.estatusRegistro === 1 ||  //Si es aspirante registrado, inicia con carga de Documentos
         datosAspirante.estatusRegistro === 2){   //Si al aspirante aun no le validan documentos, podra modificar
          cargarAspirante(datosAspirante.idProcesoElectoral, datosAspirante.idDetalleProceso, datosAspirante.claveElectorFuar, datosAspirante.folioAcceso).then(datosAspirante => {
            if(datosAspirante.estatusRegistro === 3){
              this.setState({modalAbrir: true});
            }else{
              this.props.history.push('/bandeja/modifica/'+ this.props.datosAspirante.idProcesoElectoral+"&"+this.props.datosAspirante.idDetalleProceso+"&"+this.props.datosAspirante.idEstado+"&"+this.props.datosAspirante.idDistrito+"&"+this.props.datosAspirante.folioAcceso+"&"+this.props.datosAspirante.claveElectorFuar);
            }
          });
           
      }     
    }

    abrirCerrarModal = () =>{
      this.setState({modalAbrir: false});
      window.location.reload();
    }

    descargarAcuses = () =>{
      this.props.history.push('/descargar_acuses');
    }

  // Función que valida si estamos en el módulo de registro de aspirantes
  moduloRegistroAspirante = () => {
    if(window.location.pathname === '/registro_aspirante')
        return true;
    return false;
  }

  declinarSolicitud = () =>{
    this.setState({
      modalAbrirDeclinacion:true
    })
  }

  enviaDeclinacion = () =>{
    this.props.form.validateFields((errors, values) => {
      if (!errors) {
        this.props.cargando(true)
        this.props.datosAspirante.motivoDeclinacion = this.form.getFieldValue('motivoDeclinacion');
        axios.post(process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/declina_solicitud'
            , {
                "idProcesoElectoral" : this.props.datosAspirante.idProcesoElectoral,
                "idDetalleProceso" : this.props.datosAspirante.idDetalleProceso,
                "idAspirante" : this.props.datosAspirante.idAspirante,
                "claveElectorFuar" : this.props.datosAspirante.claveElectorFuar,
                "motivoDeclinacion" : this.form.getFieldValue('motivoDeclinacion'),
                "idParticipacion" : this.props.datosAspirante.idParticipacion,
                "folioAcceso" : this.props.datosAspirante.folioAcceso
            }
            , {
                headers: {
                    'Accept': 'application/json'
                    ,'Content-Type': 'application/json'
                }
            }
        ).then(response => {
            let datosAspirante = this.props.datosAspirante
            datosAspirante.estatusRegistro = 5
            this.props.implantarAspirante(datosAspirante);

            this.props.cargando(false)
            this.props.history.push('/solicitud_declinada');
        }).catch(error => {
            console.log("Error al declinar solicitud", error);
            this.setState({cargando:false});
        });
      }
    });
  }

  /**
   * Función que consulta los datos de la Junta Distrital Ejecutiva del aspirante
   */
  consultarJuntaDistrital = () => {
    this.props.cargando(true)
    const { proceso, datosAspirante } = this.props;

    if(datosAspirante && datosAspirante.datosJunta) {
        this.setState({
            modalContactoVisible: true,
            modalContactoInfo: datosAspirante.datosJunta
        })
        this.props.cargando(false)
    } else {
        axios.post(process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/contactoJDE'
        ,{
            claveElectorFuar : datosAspirante.claveElectorFuar,
            idEstado: datosAspirante.idEstado,
            idProcesoElectoral: datosAspirante.idProcesoElectoral,
            idDetalleProceso: datosAspirante.idDetalleProceso,
            idCorte: proceso.corte,
            correoElectronico: datosAspirante.correo
        },{
            headers: {
                'Accept': 'application/json'
                ,'Content-Type': 'application/json'
            }
        },
      ).then(response => {
          if(response.data){
              this.setState({ modalContactoVisible : true,
                              modalContactoInfo : response.data
                        });

              // Se almacenan los datos de la junta en redux para no volver a ejecutar la llamada al servicio
              let informacionAspirante = datosAspirante
              informacionAspirante.datosJunta = response.data
              implantarAspirante(informacionAspirante)
          }
      }).catch(error => {
          console.error("Error al consultar contacto en SolicitudDeclinada", error);
          if (error.response){
              if (error.response.status === 409){
                  msjError = error.response.data.message;
              } else if (error.response.data && error.response.data.causa
                              && error.response.data.causa.includes("errores")){
              } else {
                  msjError = etiquetas.gral_error_contacto;
              }
          } else {
              msjError = etiquetas.gral_error_contacto;
          }
          this.setState({msjError: msjError, abrirModalError: true});
      }).finally(()=>{
        this.props.cargando(false)
      })
    }
  }

	handleContactoJDEClose = () => {
    this.setState({ modalContactoVisible : false });
  }

  cerrarErrorModal() {
    this.setState({abrirModalError:false});
  }

  cancelaDeclinacion(){
    this.setState({caracteresRetantesMotivo: 250, modalAbrirDeclinacion:false});
    this.form.setFieldsValue({motivoDeclinacion:undefined});
  }
  
  render() {
    const contacto = this.state.modalContactoInfo.map((item) =>
    <li className="vinetaContacto"><p className="text_junta"><b id="titulo_junta">{item.nombreJunta}</b><br/>
        <Icon id="icon-contacto" type="user" theme="outlined"/><b>Responsable: </b>{item.tratamiento + " " + item.nombres + " " +
                (item.primerApellido !== null ? item.primerApellido : "") + " " + (item.segundoApellido !== null ? item.segundoApellido : "")}<br/>
        <Icon id="icon-contacto" type="environment" theme="outlined"/><b>Domicilio: </b>{"Calle " + item.calle + ", No. Exterior " + item.numeroExterior + 
                (item.numeroInterior !== null ? ", No. Interior " + item.numeroInterior : "") +
                ", Col. " + item.colonia + ", C.P. " + item.codigoPostal +
                ", " + item.nombreMunicipio + ", " + item.nombreEstado + "."} <br/>
        <Icon id="icon-contacto" type="phone" theme="outlined" rotate={90}/><b>Teléfono: </b> {item.telefono !== null && item.telefono !== "null" ? item.telefono + (item.extension ? ' ext. ' + item.extension : '') : ""} <br/>
        <Icon id="icon-contacto" type="mail" theme="outlined"/><b>Correo electrónico: </b> {item.correo} <br/></p>
    </li> ) || {};

    const datosAspirante = this.props.datosAspirante;
    var estatus;
    if (datosAspirante.estatusRegistro < 4) {
      if (datosAspirante.estatusRegistro === 3)
        estatus = 4;      
      else if (datosAspirante.estatusRegistro === 2 &&
               (datosAspirante.bPlatica === 0 || datosAspirante.bPlatica === 1))
        estatus = 3;
      else
        estatus = datosAspirante.estatusRegistro;
    }
    else
      estatus = -1;

    var classPasoAnterior;

    if (datosAspirante.bObservacion)
      classPasoAnterior = 'observaciones';

    const paso1 = estatus === 0 ? "Llena tu solicitud" : "Solicitud registrada";
    const paso2 = estatus <= 1 ? "Carga tus documentos" : "Documentos cargados";
    const paso3 = estatus <= 2 ? "Ve la cápsula de inducción" : "Cápsula concluida";
    const paso4 = estatus <= 3 ? "Por finalizar" : "Has finalizado";

    const img1 = estatus === 0 ? <img src={registro} id="img-guia"/> : <img src={registro} id="img-guia"/>;
    const img2 = estatus <= 1 ?  <img src={docs} id="img-guia"/>     : <img src={conDocs} id="img-guia"/>;
    const img3 = estatus <= 2 ?  <img src={platica} id="img-guia"/>  : <img src={conPlatica} id="img-guia"/>;
    const img4 = estatus <= 3 ?  <img src={finaliza} id="img-guia"/> : <img src={finalizado} id="img-guia"/>;

    const  pasos = [{"paso" :paso1, "img": img1},
                    {"paso" :paso2, "img": img2},
                    {"paso" :paso3, "img": img3},
                    {"paso" :paso4, "img": img4}];
    
    return (
      <React.Fragment>
        <Row gutter={16} className='guia_estatus_registro_aspirante_externo'>
        {
          this.moduloRegistroAspirante() ? 
          <Row>
            <Col sm={24} md={24} lg={24}>
                <HeaderModule title= {this.props.tituloHeaderModule} />
            </Col>
          </Row> : ""
        }
          <Row>
          <Col xs={6} sm={6} md={3} lg={6}></Col>
          <Col  xs={12} sm={12} md={16} lg={12}>
            <Steps className={classPasoAnterior}
                   size="" current={estatus}
                   status=""
            >
              {pasos.map((paso, index) => {
                return <Step key={index} title=' ' description={paso.paso} icon={paso.img}/>
              })}            
            </Steps>
          </Col>
          </Row>
          {this.state.nuevo?
            <div className='div_edit'>
              <Row>
                <Col xs={24} md={12} lg={{span: 5, offset: 4}}>
                  <Button type="" icon="search"
                      htmlType="submit" 
                      onClick={this.consultarJuntaDistrital}>
                    Consultar Junta Distrital
                </Button> 
                </Col>
                <Col xs={24} md={12} lg={3}>
                  <Button type="" icon="edit"
                        
                        htmlType="submit" 
                        disabled={!this.state.permiteModificar}
                        onClick={this.modificar}
                        >
                      Modificar
                  </Button>
                </Col>
                <Col xs={24} md={12} lg={4}>
                  <Button type="" icon="download"
                        
                        htmlType="submit" 
                        disabled={!this.state.permiteDescargar}
                        onClick={this.descargarAcuses}>
                      Descargar Acuses
                  </Button>
                </Col>
                <Col xs={24} md={12} lg={4}>
                  <Button type="" icon="close-circle"
                      
                      htmlType="submit" 
                      disabled={!this.state.permiteDeclinar}
                      onClick={this.declinarSolicitud}>
                    Declinar Solicitud
                </Button> 
                </Col>
              </Row>            
              <br></br><br></br>
            </div>
            
           : null}	
        </Row>
        <Modal title={null}
                visible={this.state.modalAbrir}
                centered
                width={347}
                closable={false}
                footer={null}>
          <div style={{ fontSize: '18px', textAlign: 'center'}}>
            {etiquetas.gral_documentos_validados}
          </div>
          <br/>
          <div id="modal_botones">
            <Button className="botonesModal" style={{width: 150}} onClick={this.abrirCerrarModal}> Aceptar </Button>
          </div>
        </Modal>
        <Modal title={null}
                       centered
                       visible={this.state.modalAbrirDeclinacion}
                       onOk={null}
                       onCancel={null}
                       closable={false}
                       footer={null}
                       width="40%">

          <div className="titulosAvisoPrivacidad" style={{ fontSize: '18px', textAlign: 'center'}}>
                      Declinar Solicitud
                    </div>
                    <br/>
                    <Text style={{ color: '#1890ff' }}>
                            <Icon type="info-circle" theme="filled" style={{ fontSize: '1.0em' }} />
                            {' '}Al declinar tu solicitud, dejarás de participar en la convocatoria donde te registraste.
                        </Text>
                        <br/>
                        <Form>
                        <div>
                          
                        <TextArea nombre="motivoDeclinacion"
                                       required={true}               
                                       autoSize={{minRows: 5, maxRows: 5}}
                                       placeholder={"Describe la razón por la que decides declinar tu solicitud de registro"}
                                       form={this.props.form}
                                       maxLength={250}
                                       rules={[{
                                                max: 250
                                                , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                            }]}
                                            custom={{
                                              getValueFromEvent: (event) => {
                                                  this.setState({ caracteresRetantesMotivo : 250 - event.target.value.length});

                                                  // Se valida con la expresión regular de caracteres especiales
                                                  const regex = new RegExp(etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES)
                                                  if (regex.test(event.target.value))
                                                    // Si no hay caracteres especiales, habilitamos el botón de enviar declinación
                                                    this.setState({deshabilitarDeclinacion: false});
                                                  else
                                                    // Si hay caracteres especiales, deshabilitamos el botón de enviar declinación
                                                    this.setState({deshabilitarDeclinacion: true});

                                                  return	event.target.value;
                                              }
                                          }}/>
                                       
                           
                        </div>
                        <div style={{'textAlign': 'justify', 'fontStyle':'italic'}}>{this.state.caracteresRetantesMotivo} caracteres restantes.</div>
                        <div style={{textAlign: 'center'}}>
                          <br/>
                          <Row>
                          <Col  sm={5}></Col>
                            <Col  sm={6}>
                              
                              <Button className="button_style" style={{width: 150}} onClick={() => this.cancelaDeclinacion()}> Cancelar </Button>
                            </Col>
                            <Col  sm={2}></Col>
                            <Col  sm={6}>
                            <Button className="button_style" style={{width: 150}} disabled={this.state.caracteresRetantesMotivo === 250 || this.state.deshabilitarDeclinacion} onClick={() => this.enviaDeclinacion()}> Aceptar </Button>
                            </Col>
                          </Row>
                        
                          
                        </div>
                        </Form>
                       </Modal>

        <Modal visible={this.state.modalContactoVisible}
                title={null}
                centered={true}
                onOk={this.handleContactoJDEClose}
                onCancel={this.handleContactoJDEClose}
                footer={null}
                className="modal_contacto">
        
          <div id="modal_clave">
              <div id="modal_estado_titulo">
                  Datos de contacto
              </div>
              <div id="modal_estado_informacion">
                  Para aclarar tus dudas, puedes comunicarte vía telefónica, enviar un<br />correo electrónico o asistir directamente a la Junta Distrital Ejecutiva
              </div>
              <hr id="modal_estado_linea" />
              <Col xs={24} sm={6} md={12} lg={10}>
                  <div id="modal_contactoImgClave">
                      <img src={claveContacto} />
                  </div>
              </Col>
              <Col xs={24} sm={6} md={12} lg={12}>
                  {contacto}
              </Col>
          </div>
        </Modal>

        <Modal className="modalError"
                title={<img  src={errorImgModal} id="img-error-modal"/>}
                centered
                onCancel={()=>this.cerrarErrorModal()}
                visible={this.state.abrirModalError}
                footer={false}
                width={400}>
            {this.state.msjError}
        </Modal>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
	implantarAspirante: aspirante => dispatch(implantarAspirante(aspirante))
});

const mapStateToProps = state => {
  var datosAspirante, datosUsuario;
  var proceso = undefined;

  if (state.user.currentUser && state.user.datosAspirante) {
    datosUsuario = state.user.currentUser;
    datosAspirante = state.user.datosAspirante;

    // Obtenemos el proceso seleccionado de la store de redux
    if(state.menu.estados)
        if(state.menu.estados[state.menu.idEstado].procesos)
            proceso = state.menu.estados[state.menu.idEstado].procesos[state.menu.idDetalle];
  }
  else
    datosAspirante = {estatusRegistro: 0};

  return {
    datosUsuario: datosUsuario,
    datosAspirante: datosAspirante,
    proceso: proceso
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'guiaEstatusForm' })(GuiaEstatus)));